import { useState, useRef, useEffect } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

const DateInput = ({ selected, onChange, defaultMonth }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(selected || null);
  const [month, setMonth] = useState(selected || defaultMonth || new Date());
  const [popupStyle, setPopupStyle] = useState({});
  const ref = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    setDate(selected || null);
    if (selected) setMonth(selected);
  }, [selected]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Calculate popup position when opening
  const handleOpen = () => {
    if (!open && inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      const calendarWidth = 300;
      const viewportWidth = window.innerWidth;

      // If calendar would overflow right side, align to right edge of input
      const wouldOverflowRight = rect.left + calendarWidth > viewportWidth;

      if (wouldOverflowRight) {
        setPopupStyle({ right: 0, left: "auto" });
      } else {
        setPopupStyle({ left: 0, right: "auto" });
      }
    }
    setOpen((p) => !p);
  };

  const months = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec",
  ];

  const formatDate = (d) => {
    if (!d) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = months[d.getMonth()];
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSelect = (d) => {
    if (!d) return;
    setDate(d);
    setMonth(d);
    setOpen(false);
    onChange?.(d);
  };

  return (
    <div className="position-relative rdp-root" ref={ref}>
      <input
        ref={inputRef}
        type="text"
        className="form-control"
        placeholder="dd-MMM-yyyy"
        value={formatDate(date)}
        readOnly
        onClick={handleOpen}
      />

      {open && (
        <div
          className="shadow p-2 position-absolute"
          style={{
            zIndex: 2000,
            top: "100%",
            ...popupStyle,
          }}
        >
          <DayPicker
            mode="single"
            selected={date}
            month={month}
            onMonthChange={setMonth}
            onSelect={handleSelect}
            className="custom-calendar"
          />
        </div>
      )}
    </div>
  );
};

export default DateInput;